<template>
  <div>
    <br />
    자식 데이터:
    <input type="number" v-model="propMyNum" @keyup="updateNumber" />
  </div>
</template>

<script>
export default {
  name: 'dataTestChild',
  props: ['myNum'], //부모 데이터
  data() {
    return {
      propMyNum: this.myNum,
    };
  },
  methods: {
    updateNumber: function() {
      this.$emit('updateParentNumber', this.propMyNum); //자식에서 부모로 전송
    },
    childFunction: function() {
      alert('call child function'); //부모에서 자식 메소드 호출용
    },
  },
};
</script>
